import { useState, useEffect } from "react";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import {
  getAllPatrimonialZones,
  getAllResidentialZones,
  getAllCostaZones, // NUEVO
  getAllRusticAndSingularZones, // NUEVO
} from "../../api/zones.api";
import { deleteConsultantImage } from "../../api/consultants.api";

export default function EmailSign({
  onChange,
  selectedZones,
  backgroundImages,
  setBackgroundImages,
  consultantId,
}) {
  const [zones, setZones] = useState({
    residential: [],
    patrimonial: [],
    costa: [], // NUEVO
    rusticAndSingular: [], // NUEVO
  });

  const [previewImages, setPreviewImages] = useState({
    high: { zone1: "", zone2: "", zone3: "" },
    medium: { zone4: "", zone5: "", zone6: "" },
    low: { zone7: "", zone8: "", zone9: "" },
  });

  // Cargar las zonas
  useEffect(() => {
    const fetchZones = async () => {
      const residentialZones = await getAllResidentialZones();
      const patrimonialZones = await getAllPatrimonialZones();
      const costaZones = await getAllCostaZones(); // NUEVO
      const rusticAndSingularZones = await getAllRusticAndSingularZones(); // NUEVO

      const allZones = {
        residential: residentialZones || [],
        patrimonial: patrimonialZones || [],
        costa: costaZones || [],
        rusticAndSingular: rusticAndSingularZones || [],
      };

      setZones(allZones);
    };
    fetchZones();
  }, []);

  // Manejo de cambio de zona seleccionada
  const handleChange = (priority, zoneKey, value) => {
    // Si limpian el dropdown (value es null), limpiamos la zona
    if (!value) {
      const updatedZones = {
        ...selectedZones,
        [priority]: {
          ...selectedZones[priority],
          [zoneKey]: {},
        },
      };
      onChange(updatedZones);
      return;
    }

    // AÑADIMOS SLUG Y SUBZONE AQUÍ
    const updatedZones = {
      ...selectedZones,
      [priority]: {
        ...selectedZones[priority],
        [zoneKey]: {
          zoneId: value._id,
          name: value.name || "",
          image: backgroundImages[priority][zoneKey] || "",
          zone: value.zone,
          slug: value.slug || "", // <-- VITAL
          subzone: value.subzone || "", // <-- VITAL
        },
      },
    };

    onChange(updatedZones);
  };

  // Opciones de zonas para los Dropdowns
  const getAvailableOptions = () => {
    return [
      {
        label: "Residencial",
        items: zones.residential.map((zone) => ({
          label: zone.name,
          value: zone,
        })),
      },
      {
        label: "Patrimonial",
        items: zones.patrimonial.map((zone) => ({
          label: zone.name,
          value: zone,
        })),
      },
      {
        label: "Costa", // NUEVO
        items: zones.costa.map((zone) => ({
          label: zone.name,
          value: zone,
        })),
      },
      {
        label: "Campos Rústicos & Activos Singulares", // NUEVO
        items: zones.rusticAndSingular.map((zone) => ({
          label: zone.name,
          value: zone,
        })),
      },
    ];
  };

  // Resto del código intacto (handleImageUpload, handleDeleteImage, etc...)
  const handleImageUpload = (priority, zoneKey, e) => {
    const file = e.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const newImage = event.target.result;

      const updatedPreviewImages = {
        ...previewImages,
        [priority]: { ...previewImages[priority], [zoneKey]: newImage },
      };

      const updatedBackgroundImages = {
        ...backgroundImages,
        [priority]: { ...backgroundImages[priority], [zoneKey]: newImage },
      };

      setPreviewImages(updatedPreviewImages);
      setBackgroundImages(updatedBackgroundImages);

      const updatedZones = {
        ...selectedZones,
        [priority]: {
          ...selectedZones[priority],
          [zoneKey]: {
            ...selectedZones[priority][zoneKey],
            image: file,
          },
        },
      };

      onChange(updatedZones);
    };
    reader.readAsDataURL(file);
  };

  const handleDeleteImage = (priority, zoneKey) => {
    const imageUrl = backgroundImages[priority][zoneKey];
    const imageType = `${priority}_${zoneKey}_backgroundImage`;

    deleteConsultantImage(consultantId, { toDelete: imageUrl }, imageType).then(
      (res) => {
        const updatedBackgroundImages = {
          ...backgroundImages,
          [priority]: { ...backgroundImages[priority], [zoneKey]: "" },
        };
        setBackgroundImages(updatedBackgroundImages);

        const updatedZones = { ...selectedZones };
        updatedZones[priority][zoneKey] = {
          ...updatedZones[priority][zoneKey],
          image: "",
        };

        onChange(updatedZones);
        alert(`Imagen borrada exitosamente.`);
      },
    );
  };

  const handleDeletePreviewImage = (priority, zoneKey) => {
    const updatedPreviewImages = {
      ...previewImages,
      [priority]: { ...previewImages[priority], [zoneKey]: "" },
    };
    setPreviewImages(updatedPreviewImages);

    const updatedBackgroundImages = {
      ...backgroundImages,
      [priority]: { ...backgroundImages[priority], [zoneKey]: "" },
    };
    setBackgroundImages(updatedBackgroundImages);

    const updatedZones = { ...selectedZones };
    updatedZones[priority][zoneKey] = {
      ...updatedZones[priority][zoneKey],
      image: "",
    };

    onChange(updatedZones);
  };

  // Concatenamos todos los arrays para buscar el valor inicial
  const allZonesFlat = [
    ...zones.residential,
    ...zones.patrimonial,
    ...zones.costa,
    ...zones.rusticAndSingular,
  ];

  return (
    <section
      style={{
        width: "100%",
        margin: "0 auto",
        display: "flex",
        justifyContent: "space-evenly",
        gap: "20px",
        flexWrap: "wrap",
      }}
    >
      {["high", "medium", "low"].map((priority, priorityIndex) => (
        <div key={priority} style={{ marginBottom: "1em", width: "100%" }}>
          <h3 style={{ marginBottom: "2rem", textAlign: "left" }}>
            {priority === "high"
              ? "Primera fila"
              : priority === "medium"
                ? "Segunda fila"
                : "Tercera fila"}
          </h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "20px",
            }}
          >
            {[
              `zone${priorityIndex * 3 + 1}`,
              `zone${priorityIndex * 3 + 2}`,
              `zone${priorityIndex * 3 + 3}`,
            ].map((zoneKey) => (
              <div
                key={zoneKey}
                style={{
                  border: "1px solid black",
                  borderRadius: "10px",
                  padding: "10px",
                }}
              >
                <h4 style={{ marginBottom: "10px" }}>{`Zona - ${zoneKey.replace(
                  "zone",
                  "",
                )}`}</h4>

                <Dropdown
                  value={
                    allZonesFlat.find(
                      (z) => z._id === selectedZones[priority][zoneKey]?.zoneId,
                    ) || null
                  }
                  options={getAvailableOptions()}
                  optionGroupLabel="label"
                  optionGroupChildren="items"
                  optionLabel="label"
                  onChange={(e) => handleChange(priority, zoneKey, e.value)}
                  placeholder="Selecciona una Zona"
                  style={{ width: "100%" }}
                  filter
                />

                <div style={{ marginTop: "20px" }}>
                  <h4 style={{ marginBottom: "10px" }}>Imagen de fondo</h4>
                  {previewImages[priority][zoneKey] ? (
                    <div style={{ position: "relative" }}>
                      <img
                        src={previewImages[priority][zoneKey]}
                        alt={`Fondo ${priority} ${zoneKey}`}
                        style={{
                          width: "100%",
                          maxHeight: "200px",
                          objectFit: "cover",
                          borderBottomLeftRadius: "10px",
                          borderBottomRightRadius: "10px",
                        }}
                      />
                      <Button
                        type="button"
                        icon="pi pi-trash"
                        className="large-icon-button"
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          background: "#2b363d",
                          border: "none",
                          width: "40px",
                          height: "40px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "50%",
                          color: "white",
                        }}
                        onClick={() =>
                          handleDeletePreviewImage(priority, zoneKey)
                        }
                      />
                    </div>
                  ) : backgroundImages[priority][zoneKey] ? (
                    <div style={{ position: "relative" }}>
                      <img
                        src={backgroundImages[priority][zoneKey]}
                        alt={`Fondo ${priority} ${zoneKey}`}
                        style={{
                          width: "100%",
                          maxHeight: "200px",
                          objectFit: "cover",
                          borderBottomLeftRadius: "10px",
                          borderBottomRightRadius: "10px",
                        }}
                      />
                      <Button
                        type="button"
                        icon="pi pi-trash"
                        className="large-icon-button"
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          background: "#2b363d",
                          border: "none",
                          width: "40px",
                          height: "40px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "50%",
                          color: "white",
                        }}
                        onClick={() => handleDeleteImage(priority, zoneKey)}
                      />
                    </div>
                  ) : (
                    <FileUpload
                      name="background"
                      customUpload
                      uploadHandler={(e) =>
                        handleImageUpload(priority, zoneKey, e)
                      }
                      accept="image/*"
                      maxFileSize={20971520}
                      auto
                      chooseLabel="Cargar imagen de fondo"
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
